var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import styled from 'styled-components';

var SVG = function SVG(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.5 50.5",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M49.44 22.09a1.06 1.06 0 011.06 1.06v4.2a1.06 1.06 0 01-1.06 1.06h-5.55a18.36 18.36 0 01-5.24 10.24A18.51 18.51 0 0128.41 44v5.47a1 1 0 01-.31.75 1 1 0 01-.75.31h-4.2a1 1 0 01-.75-.31 1 1 0 01-.31-.75V44A19.14 19.14 0 016.53 28.41H1.06a1 1 0 01-.75-.31 1 1 0 01-.31-.75v-4.2a1 1 0 01.31-.75 1 1 0 01.75-.31h5.47a18.51 18.51 0 015.32-10.24 18.36 18.36 0 0110.24-5.24V1.06a1 1 0 01.31-.75 1 1 0 01.75-.31h4.2a1 1 0 01.75.31 1 1 0 01.31.75v5.55a18.71 18.71 0 0115.48 15.48zM20.35 36.88a12.48 12.48 0 009.79 0 12.48 12.48 0 006.74-6.73 12.6 12.6 0 000-9.79 12.46 12.46 0 00-6.74-6.74 12.48 12.48 0 00-9.79 0 12.48 12.48 0 00-6.73 6.74 12.48 12.48 0 000 9.79 12.51 12.51 0 006.73 6.73z",
    "data-name": "Layer 2"
  }));
};

var SvgCrosshair = styled(SVG)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      fill: ", ";\n      height: ", ";\n      width: ", ";\n    "])), function (props) {
  return props.fill ? props.fill : 'currentColor';
}, function (props) {
  return props.height ? props.height : '50';
}, function (props) {
  return props.width ? props.width : '50';
});
SvgCrosshair.displayName = SvgCrosshair;
export default SvgCrosshair;